import { LANGUAGE_CLOSE_POPUP, LANGUAGE_OPEN_POPUP } from "../actions/types";

const INIT_STATE = {
  displayPopupLanguage: false,
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case LANGUAGE_CLOSE_POPUP:
      document.body.classList.remove("modal-open");
      return INIT_STATE;
    case LANGUAGE_OPEN_POPUP:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayPopupLanguage: true,
        //displayMessage:action.payload,
      };
    default:
      return state;
  }
};
